
const layerKeys = {
  all: ["layers"] as const,
  layersByMap: (id: string) => [...layerKeys.all, id] as const,
  layersByRole: (id: string) => [...layerKeys.all, id] as const,
  layersByRoleAndClient: (roleId: string, clientId: string) =>
    [...layerKeys.all, roleId, clientId] as const,
  layersByMapAndClient: (mapId: string, clientId: string) =>
    [...layerKeys.all, mapId, clientId] as const,
  layerInfo: ["layerInfo"] as const,
  layerInfoByClient: (id: string) => [...layerKeys.layerInfo, id] as const,
  geoserverMaps: ["geoserverMaps"] as const,
  geoserverMapsByClient: (id: string) =>
    [...layerKeys.geoserverMaps, id] as const,
  attributes: ["attributes"] as const,
  attributesBylayer: (id: string) => [...layerKeys.attributes, id] as const,
  styles: ['styles'] as const,
  stylesByLayer: (name: string) => [...layerKeys.styles, name] as const,
  workspaces: ['workspaces'] as const,
};

export default layerKeys